// Why a lesson series ended (backend utils/series_stops.py CATEGORIES, plan 61).
// `reschedule` isn't a stop: picking it opens New Lesson to make the new schedule instead.
export const STOP_CATEGORIES = [
  ['reschedule',        'Rescheduling (not stopping)'],
  ['break',             'Taking a break'],
  ['schedule_conflict', 'Schedule conflict (sports, school)'],
  ['cost',              'Cost'],
  ['moving',            'Moving'],
  ['lost_interest',     'Lost interest'],
  ['switching',         'Switching instrument or teacher'],
  ['goal_reached',      'Reached their goal / seasonal'],
  ['unhappy',           'Unhappy with lessons'],
  ['unknown',           'Not sure'],
  ['other',             'Other'],
]
export const STOP_LABELS = Object.fromEntries(STOP_CATEGORIES)

export const emptyStop = () => ({ category: '', note: '', follow_up_date: '' })

// Request body fields for an end that needs a reason (lesson-edits / lesson-series PATCH).
export const stopFields = (stop) => ({
  stop_category: stop.category,
  stop_note: stop.note.trim() || null,
  stop_follow_up_date: stop.category === 'break' ? (stop.follow_up_date || null) : null,
})

// New Lesson in reschedule / start-again mode, prefilled from the old series (AppRoot.vue
// listens). Pass { replacesLessonId } or { replacesSeriesId }.
export function openReschedule(detail) {
  window.dispatchEvent(new CustomEvent('lesson-create:open', { detail }))
}
